/**
 * Push Notification API Requests
 * For admin panel to send push notifications via FCM
 */
import api from "../api";

// Get push notification history (admin)
export const getPushNotifications = async (page = 1, limit = 20, filters = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/push-notifications", { 
    params: { page, limit, ...filters } 
  });
};

// Get push notification stats
export const getPushNotificationStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "admin/push-notifications/stats");
};

// Send push notification to single user
export const sendPushNotification = async ({ userId, title, body, data, platform = "all" }) => {
  return api.getApi().post(api.getBaseUrl() + "admin/push-notifications", {
    userId,
    title,
    body,
    data,
    platform
  });
};

// Send bulk push notifications
export const sendBulkPushNotifications = async ({ userIds, title, body, data, platform = "all" }) => {
  return api.getApi().post(api.getBaseUrl() + "admin/push-notifications/bulk", {
    userIds,
    title,
    body,
    data,
    platform
  });
};

// Send test notification to yourself
export const sendTestPushNotification = async ({ title, body }) => {
  return api.getApi().post(api.getBaseUrl() + "admin/push-notifications/test", {
    title,
    body
  });
};

// Register device token
export const registerDeviceToken = async ({ deviceId, fcmToken, platform }) => {
  return api.getApi().post(api.getBaseUrl() + "admin/push-notifications/register-device", {
    deviceId,
    fcmToken,
    platform
  });
};

// Unregister device
export const unregisterDevice = async ({ deviceId }) => {
  return api.getApi().post(api.getBaseUrl() + "admin/push-notifications/unregister-device", {
    deviceId
  });
};
